import { createRxDatabase, RxDatabase } from 'rxdb';
import { getRxStorageDexie } from 'rxdb/plugins/storage-dexie';
import { ConfigCollection, configSchema } from './config';
import { DefaultErrors } from '../../model/error';
import Log from '../../util/log';

export type PlatformCollections = {
  config: ConfigCollection;
};

export type PlatformDatabase = RxDatabase<PlatformCollections>;

export function getDatabase(id: string): Promise<PlatformDatabase> {
  return createRxDatabase<PlatformCollections>({
    name: id,
    storage: getRxStorageDexie(),
  })
    .then((db) => {
      return db
        .addCollections({
          config: {
            schema: configSchema,
          },
        })
        .then(() => db);
    })
    .catch((error) => {
      Log.error(error);
      throw DefaultErrors.DATABASE_ACCESS_DENIED;
    });
}
